import '../App.css';
import '../design/loginform.css';
import { useParams, useNavigate} from 'react-router-dom';
import { Component } from 'react';
import EnvironmentService from "../service/environmentService";
import MovieService from '../service/movieService';
import UserService from '../service/userService';


function withParams(Component) {
  return props => <Component {...props} params={useParams()} Navigate={useNavigate()} />;
}

class MoviesOverview extends Component {

  constructor(props){
    super(props);

    this.MovieService = new MovieService();
    this.UserService = new UserService();
    this.environmentService = new EnvironmentService();

    this.state = {
      movies : [],
      NameInput : "",
      Dateinput : "",
      isUserAdmin : false
    }

        this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount(){
    console.log("This props " + this.props.params.uuid);

    this.getMovies();
    this.getUserInformation();
  }

  async getMovies(){
    let result = await this.MovieService.GetMovies()
   this.setState({
    movies : result
   });
  }

  handleChange({target}){
    this.setState({
        [target.name] : target.value
    });
}
async getUserInformation(){
  let userObject= await this.UserService.getMe();
  
  this.setState({
    isUserAdmin :userObject.userRoles.includes("ADMIN")
  })

}

  async RegisterMovie(event) {
    event.preventDefault();
    await this.MovieService.RegisterMovie(this.state.NameInput,this.state.Dateinput);

    this.setState({
        NameInput : "",
        Dateinput : ""
    });
    this.getMovies();
    this.hideOverlay();
  }

  showOverlay() {
        document.getElementById("overlay").style.display = "block";
    }

  hideOverlay() {
      document.getElementById("overlay").style.display = "none";
  }

  render(){
    const movies = this.state.movies;
    if(!movies) return null;
    const isUserAdmin = this.state.isUserAdmin;

    return(
       <div>
          <div id="overlay">
                    <div id='LoginDiv' className='content'>
                        <button onClick={this.hideOverlay}>Back</button><br />
                        <center><h1>New Movie</h1></center>
                        <form action="#" onSubmit={(event) => {this.RegisterMovie(event)}}>
                          <label>
                              Movie Name
                          </label><br/>
                          <input name="NameInput" type="text" value={this.state.NameInput} onChange={this.handleChange} required></input><br/>
                          <label>
                              Release Date
                          </label><br/>
                          <input name="Dateinput" type="date" value={this.state.Dateinput} onChange={this.handleChange} required></input><br/>
                          
                          <button type="submit">Submit</button>
                        </form>
                    </div>
                </div>

          <div>
            {
              isUserAdmin ?
              <button onClick={this.showOverlay}>Create New</button> : ""

            }
            <span className="page-title">Movies</span>
          </div>
          <div className="grid-container">
            {movies.map((movie) =>(
              <div className="grid-item" key={movie.uuid}>
                <a href={this.environmentService.getFrontEndEnvironmentHost() + '/movie/detail/' + movie.uuid} className='link-hidden'>
                  <div>
                    <span> 
                        {movie.name}<br/>
                        {movie.releaseDate}
                    </span>
                  </div>
                </a>
              </div>
            ))
          }
          </div>
       </div> 
      )

  }




}

export default withParams(MoviesOverview);
